import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { getByRegistroReferencia, putOne } from "../../../../database/dbRegistroGeneral";
import { Avatar, Box, Button, Container, createTheme, CssBaseline, Divider, FormControlLabel, Grid, Paper, Switch, TextField, ThemeProvider, Typography } from "@mui/material";
import Swal from "sweetalert2";
import { CustomDialog } from "../../../modules/dialogs/CustomDialog";
import { FileUploadCustom } from "../../../modules/ui/FileUploadCustom";
import { isBefore } from "date-fns";

export const Sina2025ConcursoFotografia = () => {
    // Hook que obtiene los parametros que se envian por la url
    const { referencia } = useParams();


    const [record, setRecord] = useState({});

    const [isParticipating, setIsParticipating] = useState(true);
    const [driveURL, setDriveURL] = useState('');

    const [isDataLoaded, setisDataLoaded] = useState(false);
    const [uploadingFile, setUploadingFile] = useState(false);



    const handleConcursoFotoChanged = ({ checked }) => {
        setIsParticipating(checked);

        if (checked){ 
            record.infoAdicional.concursoFoto = '1';
            record.infoAdicional.concursoFotoArchivos = {};
        } else {
            record.infoAdicional.concursoFoto = '0';
            record.infoAdicional.concursoFotoArchivos = null;
            setDriveURL('');
        }
        
    }

    const handleConcursoFotoDocsURLChange = ({ target }) => {
        const { value } = target;
        setDriveURL(value);
        record.infoAdicional.concursoFotoDocsURL = value;
    }

    const handleFileUploaded = ({exito, mensaje, data }, param) => {
        console.log({exito, mensaje, data }, param);
        //* En caso de error, notifica
        if (!exito) {
            Swal.fire({
                title: 'Error', 
                text: 'Falló la carga del archivo / Upload file failed', 
                icon: 'error',
                footer: 'Por favor, reporte la situación / Please, report',
                showConfirmButton: false,
                allowEscapeKey: false,
                allowOutsideClick: false,
            })
            return;
        }

        record.infoAdicional.concursoFotoArchivos[param] = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ data }`;
        // setInvoiceData({ ...invoiceData, [param]: `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ data }`, })
    }

    const handleGuardarCambios = async() => {
        console.log({record});

        // Contruimos el objeto para actualizar el registro
        const recordToSave = { ...record, infoAdicional: JSON.stringify(record.infoAdicional) };
        console.log({recordToSave});
        
        // Se actualiza el registro
        const { exito } = await putOne(record.id, recordToSave);
        
        if (exito) {
            Swal.fire({
                title: '¡Registro actualizado!',
                text: 'Puede cerrar la ventana o continuar modificando.',
                showConfirmButton: false,
                timer: 3000
            })
        } else {
            Swal.fire({
                title: '¡Error al actualizar!',
                text: 'Presione -Ok-, tome una captura de pantalla y notifique al desarrollador.',
                icon: 'error',
            })
        }
    }


    //* Se recupera y formatea la data
    useEffect(async() => {

        const { data } = await getByRegistroReferencia(referencia);
        const recordTmp = data[0];

        let infoAdicional = JSON.parse(recordTmp.infoAdicional);
        if (infoAdicional.concursoFoto === '1') {
            setIsParticipating(true)
            infoAdicional.concursoFotoArchivos = {};
        } else {
            setIsParticipating(false)
        }


        // infoAdicional.concursoFoto === '1'
        // ? setIsParticipating(true)
        // : setIsParticipating(false)
        
        setDriveURL(infoAdicional.concursoFotoDocsURL);

        const recordToShow = { ...recordTmp, infoAdicional: infoAdicional };
        console.log(recordToShow)
        setRecord(recordToShow);

        setisDataLoaded(true);
        console.log({infoAdicional});
    }, [ referencia ])



    useEffect(() => {
        const todayDate = new Date();
        const limitDate = new Date(2025, 9, 31);
        console.log({limitDate});
        const onTime = isBefore(todayDate, limitDate)
        console.log({onTime});

        if (!onTime) {
            Swal.fire({
                title: "¡Gracias! / Thank you!",
                text: 'La fecha límite de participación ha sido superada / Participation date expired.',
                icon: 'info',
                showConfirmButton: false,
                allowEscapeKey: false,
                allowOutsideClick: false,
            })
        }
    }, [ ])
    

    return (

        <ThemeProvider theme={createTheme()}>
        <CustomDialog title='Cargando archivo...' show={ uploadingFile } />
        <Container component="main">
        <CssBaseline />

        <CustomDialog title='Por favor espere / Please wait' show={ !isDataLoaded } />

        <Box m={ 2 } display='flex' flexDirection='row' alignItems='center'>
            <Avatar src='https://aena.mx/images/nicepage-images/80f8a68a08b4341bcc455d466709dc31.png' sx={{ width: 100, height: 'auto', px: 2 }} />
            <Box>
                <Typography fontSize={ 20 } fontWeight={ 900 }>Simposio Internacional en Nutrición Acuícola</Typography>
                <Typography fontSize={ 20 }>Concurso de fotografía / Photography contest</Typography>
            </Box>
        </Box>

        {
            isDataLoaded &&
            <Paper elevation={ 4 } sx={{ m: 2, p: 2 }}>
                <Grid container spacing={ 2 }>
                    <Grid item xs={ 6 }>
                        <Typography fontSize={ 24 } fontWeight={ 900 }>
                            { `${ record.partApellidoPaterno } ${ record.partApellidoMaterno } ${ record.partNombres }` }
                        </Typography>
                        <Typography color='blue'>{ record.partCorreo }</Typography>
                        <Typography>{ referencia }</Typography>
                    </Grid>
                    <Grid item xs={ 6 }>
                        <Typography>Modalidad / Modality: <strong>{ record.infoAdicional.modalidad }</strong></Typography>
                        <Typography>Ocupación/puesto / Position: <strong>{ record.tipoRegistro }</strong></Typography>
                        {
                            record.tipoRegistroDocURL !== ''
                            ? <a href={ record.tipoRegistroDocURL } target='_blank'>Consultar documento / View document</a>
                            : <></>
                        }
                    </Grid>

                    <Grid item xs={ 12 }><Divider sx={{ my: 1 }}/></Grid>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch 
                                    color='primary' 
                                    checked={ isParticipating } 
                                    onChange={ ({ target }) => handleConcursoFotoChanged(target) }
                                />
                            }
                            label={  
                                <Typography>
                                    ¿Participará en el concurso de fotografía científica? / Will you participate in the scientific photography contest?
                                </Typography> 
                            }
                            sx={{ mb: 1 }} 
                        />  

                    </Grid>
                    <Grid item xs={ 12 } display={ isParticipating ? 'flex' : 'none' } className='fadeIn'>
                        <Grid container spacing={ 1 }>
                            <Grid item xs={ 12 }>
                                <Typography fontWeight={ 900 }>Foto 1 / Photo #1</Typography>
                                {
                                    record.infoAdicional.concursoFotoArchivos && record.infoAdicional.concursoFotoArchivos.foto1
                                    ? <a href={ record.infoAdicional.concursoFotoArchivos.foto1 } target='_blank'>
                                        Archivo actual / Current file
                                    </a>
                                    : <></>
                                }
                                <FileUploadCustom 
                                    helperText='Anexar archivo JPG / Add JPG file'
                                    //* Ejecuta 'handleFileUploaded' con el resultado del upload y el id del control
                                    parentCallback={ (e) => handleFileUploaded(e, 'foto1') }
                                    //* Muestra el waiting dialog en lo se realiza el upload
                                    parentWaitingCallback={ (val) => setUploadingFile(val) }
                                    saveFileAs= { `${ referencia }_foto1` }
                                    validTypes ={ ['jpg'] }
                                    maxFileWeight={ 5000000 }
                                    variant='standard'
                                />
                            </Grid>
                            <Grid item xs={ 12 }>
                                <Typography fontWeight={ 900 }>Foto 2 / Photo #2</Typography>
                                {
                                    record.infoAdicional.concursoFotoArchivos && record.infoAdicional.concursoFotoArchivos.foto2
                                    ? <a href={ record.infoAdicional.concursoFotoArchivos.foto2 } target='_blank'>
                                        Archivo actual / Current file
                                    </a>
                                    : <></>
                                }
                                <FileUploadCustom 
                                    helperText='Anexar archivo JPG / Add JPG file'
                                    //* Ejecuta 'handleFileUploaded' con el resultado del upload y el id del control
                                    parentCallback={ (e) => handleFileUploaded(e, 'foto2') }
                                    //* Muestra el waiting dialog en lo se realiza el upload
                                    parentWaitingCallback={ (val) => setUploadingFile(val) }
                                    saveFileAs= { `${ referencia }_foto2` }
                                    validTypes ={ ['jpg'] }
                                    maxFileWeight={ 5000000 }
                                    variant='standard'
                                />
                            </Grid>
                            <Grid item xs={ 12 }>
                                <Typography fontWeight={ 900 }>Autor(es) y descripción de la(s) fotografía(s) / Authors and photo description</Typography>
                                {
                                    record.infoAdicional.concursoFotoArchivos && record.infoAdicional.concursoFotoArchivos.listaAutores
                                    ? <a href={ record.infoAdicional.concursoFotoArchivos.listaAutores } target='_blank'>
                                        Archivo actual / Current file
                                    </a>
                                    : <></>
                                }
                                <FileUploadCustom 
                                    helperText='Anexar archivo PDF / Add PDF file'
                                    //* Ejecuta 'handleFileUploaded' con el resultado del upload y el id del control
                                    parentCallback={ (e) => handleFileUploaded(e, 'listaAutores') }
                                    //* Muestra el waiting dialog en lo se realiza el upload
                                    parentWaitingCallback={ (val) => setUploadingFile(val) }
                                    saveFileAs= { `${ referencia }_listaAutores` }
                                    validTypes ={ ['pdf'] }
                                    variant='standard'
                                />
                            </Grid>
                            <Grid item xs={ 12 }>
                            <Typography fontWeight={ 900 }>Carta de Autorización / Authorization letter</Typography>
                                {
                                    record.infoAdicional.concursoFotoArchivos && record.infoAdicional.concursoFotoArchivos.cartaFirmada
                                    ? <a href={ record.infoAdicional.concursoFotoArchivos.cartaFirmada } target='_blank'>
                                        Archivo actual / Current file
                                    </a>
                                    : <></>
                                }
                                <FileUploadCustom 
                                    helperText='Anexar archivo PDF / Add PDF file'
                                    //* Ejecuta 'handleFileUploaded' con el resultado del upload y el id del control
                                    parentCallback={ (e) => handleFileUploaded(e, 'cartaFirmada') }
                                    //* Muestra el waiting dialog en lo se realiza el upload
                                    parentWaitingCallback={ (val) => setUploadingFile(val) }
                                    saveFileAs= { `${ referencia }_cartaFirmada` }
                                    validTypes ={ ['pdf'] }
                                    variant='standard'
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={ 12 }>
                        <Box display='flex' flexDirection='row' justifyContent='flex-end' alignItems='center'>
                            
                            <Button 
                                variant='contained' 
                                onClick={ handleGuardarCambios }
                                size='small'
                                color='warning'
                            >
                                Guardar cambios / Save changes
                            </Button>
                        </Box>
                    </Grid>


                </Grid>
            </Paper>
        }
        </Container>
        </ThemeProvider>
    )
}
